/* Keep Vetro's native scrolling and start each menu view at its first choice. */
(() => {
  const bind = () => {
    const dialog = document.querySelector('#menu-drawer.ae-white-menu');
    if (!dialog || dialog.dataset.aeScrollReset) return;
    const scroller = dialog.querySelector('.hdt-menu-drawer__inner');
    if (!scroller) return;
    dialog.dataset.aeScrollReset = 'true';
    const reset = () => { scroller.scrollTop = 0; };
    const observer = new MutationObserver(reset);
    observer.observe(dialog, { attributes: true, attributeFilter: ['open'] });
    dialog.querySelectorAll('.hdt-menu-drawer__nav, .hdt-menu-drawer__panel').forEach(panel => {
      observer.observe(panel, { attributes: true, attributeFilter: ['hidden'] });
    });
    const section = dialog.closest('.shopify-section');
    section?.addEventListener('shopify:section:unload', () => observer.disconnect(), { once: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind, { once: true });
  else bind();
  document.addEventListener('shopify:section:load', bind);
})();
